export const getEmployeeGroupsFromEmployees = (
  employees: Employee[],
  allEmployeeGroups: EmployeeGroup[] | undefined,
) => {
  const employeeGroupsWithEmployees = employees.flatMap((emp) => emp.EmployeeGroups);

  const uniqueGroups: Record<number, EmployeeGroup> = {};
  employeeGroupsWithEmployees.forEach((eg) => {
    uniqueGroups[eg.employeeGroupId] = eg;
  });

  // We check employee groups in case employee group state has updated but the employees have not
  return (allEmployeeGroups || []).filter((group) => !!uniqueGroups[group.employeeGroupId]);
};

export const getEmployeeGroupCountsFromEmployees = (employees: Employee[]) => {
  const employeeGroupsWithEmployees = employees.flatMap((emp) => emp.EmployeeGroups);

  const groupCounts = employeeGroupsWithEmployees.reduce((groupCountMap, group) => {
    if (groupCountMap[group.employeeGroupId]) {
      groupCountMap[group.employeeGroupId] += 1;
    } else {
      groupCountMap[group.employeeGroupId] = 1;
    }

    return groupCountMap;
  }, {} as Record<number, number>);

  return groupCounts;
};
